import { clients } from 'lib/https';
import { ConfigurationSettings } from 'models/configuration-settings';

export interface NotificationFeedRequest {
  page: number;
  pageSize: number;
  filter?: any | null;
  sort?: any | null;
  projectKey?: string;
}

export interface NotificationItem {
  id: string;
  title: string;
  message: string;
  type: string;
  timestamp: string;
  read: boolean;
  [key: string]: any;
}

export interface NotificationFeedResponse {
  data: NotificationItem[];
  totalCount: number;
  unseenCount: number;
  page?: number;
  pageSize?: number;
  errors?: any;
  [key: string]: any;
}

export interface UpdateNotificationVisibilityRequest {
  itemIds?: string[];
  seen?: boolean;
  read?: boolean;
  MarkAllRead?: boolean;
}

export interface UpdateNotificationVisibilityResponse {
  isSuccess?: boolean;
  [key: string]: any;
}

/**
 * Fetches notifications from the notification feed
 */
export const getNotificationFeed = async (
  config: ConfigurationSettings,
  request: NotificationFeedRequest
): Promise<NotificationFeedResponse> => {
  const queryParams = new URLSearchParams({
    page: String(request.page ?? 0),
    pageSize: String(request.pageSize ?? 10),
  });

  const baseUrl = (config.paths.logicBaseUrl || `https://${config.paths.baseUrl}/logic/v4`).replace(/\/+$/, '');
  const url = `${baseUrl}/Notifier/GetNotifications?${queryParams.toString()}`;
  const response = await clients.get<any>(url, config.blocksKey);

  let payload = response ?? {};
  if (Array.isArray(response?.data)) {
    payload = response;
  } else if (response?.data && typeof response.data === 'object') {
    payload = response.data;
  } else if (response?.Data && typeof response.Data === 'object' && !Array.isArray(response.Data)) {
    payload = response.Data;
  }

  let notifications: NotificationItem[] = [];
  if (Array.isArray(payload.notifications)) {
    notifications = payload.notifications;
  } else if (Array.isArray(payload.Notifications)) {
    notifications = payload.Notifications;
  } else if (Array.isArray(response?.data)) {
    notifications = response.data;
  }
  const totalCount =
    payload.totalNotificationsCount ??
    payload.TotalNotificationsCount ??
    payload.totalCount ??
    notifications.length;
  const unseenCount =
    payload.unReadNotificationsCount ??
    payload.UnReadNotificationsCount ??
    payload.unseenCount ??
    0;

  return {
    data: notifications,
    totalCount,
    unseenCount,
    page: request.page,
    pageSize: request.pageSize,
  };
};

/**
 * Updates the visibility status of notifications (marks them as seen/read)
 */
export const updateNotificationVisibility = async (
  config: ConfigurationSettings,
  request: UpdateNotificationVisibilityRequest
): Promise<UpdateNotificationVisibilityResponse> => {
  const baseUrl = (config.paths.logicBaseUrl || `https://${config.paths.baseUrl}/logic/v4`).replace(/\/+$/, '');
  if (request.MarkAllRead) {
    const url = `${baseUrl}/Notifier/MarkAllNotificationAsRead`;
    return clients.post<UpdateNotificationVisibilityResponse>(
      url,
      config.blocksKey,
      JSON.stringify({})
    );
  }

  const url = `${baseUrl}/Notifier/MarkNotificationAsRead`;
  const payload = {
    id: request.itemIds?.[0] || '',
    itemIds: request.itemIds,
    seen: request.seen ?? true,
    read: request.read ?? true,
  };

  return clients.post<UpdateNotificationVisibilityResponse>(
    url,
    config.blocksKey,
    JSON.stringify(payload)
  );
};
